(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('RaceSearch', RaceSearch);

    RaceSearch.$inject = ['$resource'];

    function RaceSearch($resource) {
        var resourceUrl =  'api/_search/races/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
